"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useColorUtils = void 0;
var _react = require("react");
var _useTheme = _interopRequireDefault(require("@mui/material/styles/useTheme.js"));
var _Colors = _interopRequireDefault(require("../styles/Colors"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useColorUtils = function useColorUtils() {
  var theme = (0, _useTheme.default)();
  var getThemeColor = (0, _react.useCallback)(function (paletteKey) {
    var _theme$palette, _theme$palette2;
    return paletteKey && (theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette2 = _theme$palette[paletteKey]) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.main);
  }, [theme]);
  return {
    getThemeColor: getThemeColor,
    getConstColor: function getConstColor(constKey) {
      return constKey && (_Colors.default === null || _Colors.default === void 0 ? void 0 : _Colors.default[constKey]);
    }
  };
};
exports.useColorUtils = useColorUtils;